import { h2, paragraph, paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  margin-bottom: 34px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(600px, 100%), 1fr));
  column-gap: 34px;
  row-gap: 5px;
  width: 100%;
  justify-items: center;
  @media screen and (max-width: 1301px) {
    grid-template-columns: repeat(auto-fit, minmax(min(400px, 100%), 1fr));
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(auto-fit, minmax(min(350px, 100%), 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.softBlack};
  margin-bottom: 10px;
`;

const CardLink = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-decoration: none;
  ${paragraphCss};
  color: ${({ theme }) => theme.colors.softBlack};
`;

const TitlesWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  gap: 7px;

  @media screen and (max-width: 992px) {
    margin-top: 2px;
    flex-direction: column;
    gap: 0;
  }
`;
const FirstTitle = styled(paragraph)`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  @media screen and (max-width: 992px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const SecondTitle = styled(FirstTitle)`
  font-weight: 400;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
`;

const CardImage = styled(GatsbyImage)`
  transition: transform 0.3s ease-in-out;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  &:hover {
    transform: scale(1.05);
  }
`;

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
`;

const Filter = styled.div<{ active: boolean }>`
  position: relative;
  ${paragraphCss};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.tango};
  width: 65px;
  margin: 20px 0;

  gap: 10px;
  cursor: pointer;

  .line {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateX(-50%);
    width: 10px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.tango};
  }

  .standing {
    transition: all 0.3s ease-in-out;
    transform: translateX(-50%)
      ${({ active }) => (!active ? "rotate(90deg)" : "rotate(0deg)")};
  }
`;

const FilterOptions = styled.div<{ active: boolean }>`
  ${paragraphCss};
  display: flex;
  gap: 20px;
  color: ${({ theme }) => theme.colors.softBlack};
  transition: all 0.3s ease-in-out;
  visibility: ${({ active }) => (active ? "visible" : "hidden")};
  opacity: ${({ active }) => (active ? "1" : "0")};
`;

const FilterOption = styled.div<{ active: boolean }>`
  ${({ active, theme }) =>
    active
      ? `border-bottom: 2px solid ${theme.colors.softBlack};`
      : "border-bottom: 2px solid transparent;"};
  cursor: pointer;
  transition: all 0.2s;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      color: ${({ active, theme }) => (!active ? theme.colors.tango : "")};
    }
  }
`;

const LoadMoreButton = styled(paragraph)`
  margin-top: 30px;
  color: ${({ theme }) => theme.colors.tango};
  cursor: pointer;
`;

const S = {
  Container,
  Grid,
  Title,
  CardLink,
  TitlesWrapper,
  FirstTitle,
  SecondTitle,
  ImageWrapper,
  CardImage,
  FilterWrapper,
  Filter,
  FilterOptions,
  FilterOption,
  LoadMoreButton,
};

export default S;
